import React, { useState } from "react";

import { AppTopbar } from "../../components/Header/AppTopbar";
import { TabMenu } from "primereact/tabmenu";

import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "../../../src/assets/layout/layout.scss";
// import Login from "../../components/login/Login";
// import Wblogin from "../../components/wblogin/Wblogin";
import Wbconfigure from "../../components/wblogin/Wbconfigure";
import Centralbanksetup from "../../components/login/Centralbanksetup";
import Autoconfigure from "../../components/login/Autoconfigure";
import Autoconfigurewb from "../../components/wblogin/Autoconfigurewb";
import Createassets from "../../components/login/Createassets";
import Enableassets from "../../components/login/Enableassets";
import Transmitassets from "../../components/login/Transmitassets";
import Cbhealthcheck from "../../components/login/Cbhealthcheck";
import { GiTwoCoins } from "react-icons/gi";
import TabMenubar from "../../components/tabmenubar/TabMenubar";
import Hero from "../../components/hero/Hero";
import { NavLink } from "react-router-dom";

//      <Hero />

const Admincentral = () => {
  const [activeone, setActiveone] = useState(0);
  const [activetwo, setActivetwo] = useState(0);

  const wizardItems = [
    {
      label: "AUTO CONFIGURE ",
      icon: "pi text-xl text-blue-500 pi-fw pi-cog",
    },

    {
      label: "CONFIGURE ",
      icon: "pi text-xl text-blue-500 pi-fw pi-bolt",
    },
    {
      label: "ASSETS DISABLE/ENABLE ",
      icon: "pi text-xl text-blue-500 pi-fw pi-unlock",
    },
    {
      label: "CREATE ASSETS ",
      icon: <GiTwoCoins className="pi text-2xl text-blue-500 pi-fw " />,
    },
    {
      label: "TRANSMIT ASSETS",
      icon: "pi text-xl text-blue-500 pi-fw pi-sort-amount-up-alt",
    },
    {
      label: "HEALTH CHECK",
      icon: "pi text-xl text-blue-500 pi-fw pi-check-circle",
    },
  ];

  const wizardItems2 = [
    {
      label: "AUTO CONFIGURE ",
      // icon: "pi text-3xl pi-fw pi-sort-amount-up-alt",
    },

    {
      label: "CONFIGURE ",
      // icon: "pi text-3xl pi-fw pi-sort-amount-up-alt",
    },
  ];

  const ToggleOne = () => {
    if (activeone === 0) {
      return <Autoconfigure />;
    }
    if (activeone === 1) {
      return <Centralbanksetup />;
    }
    if (activeone === 2) {
      return <Enableassets />;
    }
    if (activeone === 3) {
      return <Createassets />;
    }
    if (activeone === 4) {
      return <Transmitassets />;
      //return <Createassets />
    }
    if (activeone === 5) {
      return <Cbhealthcheck />;
    }
  };

  const ToggleTwo = () => {
    if (activetwo === 0) {
      return <Autoconfigurewb />;
      //  return <Wbconfigure />
    }
    if (activetwo === 1) {
      //  return <Autoconfigurewb />
      return <Wbconfigure />;
    }
  };

  return (
    <>
      <div className="grid p-fluid p-5 justify-content-center">
        <div className="row-12  col-12 md:col-10  p-5">
          <div className="card card-w-title border-1 border-100">
            <TabMenu
              model={wizardItems}
              activeIndex={activeone}
              onTabChange={(e) => setActiveone(e.index)}
              id={wizardItems.id}
              style={{ fontSize: "1.2rem" }}
              className="text-xl"
            />

            {ToggleOne()}
          </div>
        </div>
      </div>
    </>
  );
};

export default Admincentral;
